import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { TrainingCourseSectionState } from 'app/_models/training/training-course-section-state';
import { TrainingCourseSection } from 'app/_models/training/training-course-section.model';
import { NotificationService } from 'app/_services/notification.service';
import { TrainingService } from 'app/_services/training.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'training-question',
  templateUrl: './training-question.component.html',
})
export class TrainingQuestionComponent implements OnInit {
  @Input() sectionData: TrainingCourseSection;
  @Input() workerUserCourseId: number;
  @Input() backLink: string[];
  @Input() userCourseType: string;
  @Output() onGoToNextSection = new EventEmitter<any>();

  public mainForm: any;
  public isComplete = false;
  public canLeave = false;

  constructor(
    private trainingService: TrainingService,
    private fb: FormBuilder,
    private router: Router,
    private notificationService: NotificationService,
    globals: Globals,
  ) { }

  ngOnInit() {
    const questionAndAnswers = this.sectionData.questions;
    const questionsFormArray = this.fb.array([]);
    this.isComplete = this.sectionData.sectionStatus === TrainingCourseSectionState.Completed;

    for (let i = 0; i < questionAndAnswers.length; i++) {
      const questionFormGroup = this.fb.group({
        text: [questionAndAnswers[i].question.text],
        id: [questionAndAnswers[i].question.id],
        order: [questionAndAnswers[i].question.order],
        options: [questionAndAnswers[i].answers],
      });

      questionsFormArray.push(this.fb.group({
        question: questionFormGroup,
        answer: new FormControl(null, [Validators.required]),
      }));
    }

    this.mainForm = this.fb.group({
      questions: questionsFormArray,
    });
  }

  public submitAnswers() {
    const formValue = this.mainForm.value;

    const questionAndAnswerIds = formValue.questions.map((questionFormGroup) => {
      return {
        questionId: questionFormGroup.question.id,
        answerId: questionFormGroup.answer,
      };
    });

    const body = {
      workerUserCourseId: this.workerUserCourseId,
      courseSectionId: this.sectionData.courseSectionId,
      questionAnswers: questionAndAnswerIds,
    };

    this.trainingService.submitQuizAnswers(body).subscribe(response => {
      if (response.status === 'FAIL') {
        console.log('Got: ', response.actualScore, '/', response.targetScore);
        Swal.fire('Unsuccessful', 'Some of the answers are incorrect', 'error');
      } else {
        this.notificationService.notify('success', 'Success',
          this.userCourseType === 'contractor' ? 'This section is complete' : 'You have passed this section of the induction');

        this.canLeave = true;

        this.onGoToNextSection.emit();
      }
      // TODO error catching, or let the message propagate?
    });
  }
}
